/**
 * Billing redirect — moved to Settings > Billing
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/analytics/billing')({
  beforeLoad: () => {
    throw redirect({ to: '/settings', search: { section: 'billing' } });
  },
  component: () => null,
});
